/* realsport 比赛列表单场比赛相关数据 */
import { computed, unref, onMounted, onUnmounted, onDeactivated, onActivated } from '@vue/composition-api'
import { isLiveMatch, getMatchStatusDescription } from './status'
import useMatchTime from './composables/useMatchTime.js'
import useMatchLink from './composables/useMatchLink'
import useMatchPush from './composables/useMatchPush'
import useMatchMarket from './composables/useMatchMarket'

const isPreMatch = (status) => status === 0 || status === 7

/**
 *
 * @param {Object} props
 * @param {Array} options.sublist 订阅列表 [], 支持 ['match', 'market', 'odds'], 默认为空
 * @returns
 */
export default function useMatch(props, { sublist = null } = {}) {
  // const { event, marketIds, excludeStages = null } = props
  const event = props.event
  const marketIds = props.marketIds
  const excludeStages = props.excludeStages ?? null

  const isSubMatch = sublist && sublist.includes('match')
  const [match, subMatch] = useMatchPush(unref(event), isSubMatch)
  const { marketMap, subMarket, subOutcomes } = useMatchMarket({ event: match, marketIds, isSubMatch })

  // 比赛时间
  const { showTime: matchTime, formattedStoppageTime } = useMatchTime(match, props.timeOptions)
  const matchLink = useMatchLink(match)
  const ariaLabel = `${unref(event).homeTeam} vs ${unref(event).awayTeam}`

  const isLive = computed(() => isLiveMatch(match.status))
  const server = computed(() => match.server)
  const isBooked = computed(() => /^booked$/i.test(match.bookingStatus))
  const isActive = computed(() => [0, 1, 2, 7].includes(match.status))

  // 当前比赛阶段
  const matchStage = computed(() => {
    const { sportId, statusDescription } = match
    return getMatchStatusDescription({ sportId, statusDescription }, excludeStages)
  })

  // 订阅/取消订阅比赛。 isSub false 取消订阅
  const subPush = (isSub = true) => {
    if (isPreMatch(match.status)) {
      // 开赛时间大于 6 小时不订阅
      const isOver6Hours = (match.startTime - Date.now()) / 3600000 > 6
      if (isOver6Hours) {
        return
      }
    }
    subMatch(isSub)
    subMarket(isSub)
    subOutcomes(isSub)
  }

  onMounted(() => {
    if (isSubMatch) {
      subPush()
    }
  })

  onUnmounted(() => {
    if (isSubMatch) {
      subPush(false)
    }
  })

  onActivated(() => {
    if (isSubMatch) {
      subPush()
    }
  })

  onDeactivated(() => {
    if (isSubMatch) {
      subPush(false)
    }
  })

  return {
    match,
    marketMap,
    isLive,
    isBooked,
    isActive,
    server,
    matchTime,
    formattedStoppageTime,
    matchLink,
    ariaLabel,
    matchStage
  }
}
